import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Menu, Table, Header, Icon, Breadcrumb, Segment, Dropdown, Grid, Button, Input, Label, Message, } from 'semantic-ui-react';
import moment from 'moment';
import { ColumnDefinition, usePublicWorkshopList } from './usePublicWorkshopList';
import { SimplePageBar } from '../../Common/CommonComponents/SimplePageBar';
import { utils } from '../../../helpers/utils';


export function PublicWorkshopList() {

    const history = useHistory();
    const inputClassName = 'ui icon input fluid search-input';
    const [columns, masterData, recordsPerPage, totalRecords, pageNum,
        pageSizeOptions, searchRef, searchText, data, isLoading, sortOrderDesc, sortByField,
        isUpcoming, fromDate, toDate, fromDateRef, toDateRef, workshopTypeId,
        handlePageSizeChange, handleSearchChange, resetSearch, handlePaginationChange, handleSortChange, handleIsUpcomingChange,
        handleFromDateChange, handleToDateChange, resetFromDate, resetToDate, handleWorkshopTypeChange
    ] = usePublicWorkshopList(false);

    const totalPages: number = Math.ceil(totalRecords / recordsPerPage);

    const paginationArray: (number | string)[] = utils.getPaginationArray(totalPages, pageNum);

    const handleCreateNew = () => {
        history.push('/editWorkshop/0');
    };

    const yesterday = moment().add(-1, 'day').format('yyyy-MM-DD');
    const today = moment().format('yyyy-MM-DD');
    const tomorrow = moment().add(1, 'day').format('yyyy-MM-DD');

    return (
        <Container className='dashboard-container'>
            <div style={{ position: 'relative', width: '100%', marginTop: '1rem' }}>
                <Header as='h1' style={{ display: 'inline' }}>Job Seeker Workshops</Header>
            </div>
            <hr />
            <Breadcrumb>
                <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section active>Job Seeker Workshops</Breadcrumb.Section>
            </Breadcrumb>
            <Message info
                icon='info circle'
                content='Click on a workshop to register job seeker for that workshop.'
            >
                
            </Message>
            <Segment loading={isLoading}>
                <Table basic='very' striped>
                    <Table.Header>
                        <Table.Row>
                            {
                                columns.map((column: ColumnDefinition, index: number) => {
                                    return <Table.HeaderCell key={index}
                                        
                                    >
                                        <div className='data-grid header-wrapper'>{column.columnHeader}
                                        </div>
                                    </Table.HeaderCell>
                                })
                            }
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {
                            data.length === 0 &&
                            <Table.Row>
                                <Table.Cell colSpan={columns.length}>No data avaliable</Table.Cell>
                            </Table.Row>
                        }
                        {
                            data.length > 0 &&
                            data.map((row, rowIndex) => {
                                return (
                                    <Table.Row key={rowIndex}>
                                        {
                                            columns.map((col, colIndex) => {
                                                if (col.decorator) {
                                                    return (
                                                        <Table.Cell key={colIndex}>{
                                                            col.decorator(row, data, rowIndex, colIndex)
                                                        }</Table.Cell>
                                                    );
                                                } else {
                                                    return <Table.Cell key={colIndex}>{row[col.columnName]}</Table.Cell>
                                                }

                                            })
                                        }

                                    </Table.Row>
                                );
                            })
                        }

                    </Table.Body>
                </Table>
            </Segment>


        </Container>
    );
}